import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateSmallOrderComponent } from './create-small-order.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: CreateSmallOrderComponent,
      },
    ],
    data: {
      allowedRoles: ['pmo', 'admin',]
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateSmallOrderRoutingModule { }
